import { queryKeys } from '../../queryKeys';
import useQuery from '../base/useQuery';

export function useUnreadNotificationsCount() {
  const { queryFn, queryKey } = queryKeys.notifications.unreadCount();
  return useQuery({ queryFn, queryKey, refetchInterval: 60_000 });
}
